import { render } from "./ReturnCreate.vue?vue&type=template&id=7ee4c4d2"
import script from "./ReturnCreate.vue?vue&type=script&lang=js"
export * from "./ReturnCreate.vue?vue&type=script&lang=js"

import "./ReturnCreate.vue?vue&type=style&index=0&id=7ee4c4d2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__